module.exports = __webpack_public_path__ + "media/CountLetsGo.b4745774.mp3";